<template>
  <el-dialog
    :visible.sync="visited"
    title="登录大日化"
    v-loading.fullscreen="loading"
    element-loading-text="正在获取登录信息"
    width="25%">
    <div class="login-container">
      <el-tabs v-model="loginType" style="width: 100%">
        <el-tab-pane label="账号密码登录" name="0">
          <el-form
            label-position="left" :model="loginForm0"
            :rules="rules0" ref="loginForm0" label-width="0px">
            <el-form-item prop="userName">
              <el-input type="text" v-model="loginForm0.userName" placeholder="请输入账号/手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="loginForm0.password" @keyup.enter.native="handleSubmit('loginForm0')"
                        auto-complete="off" placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-form>
          <div>
            <el-button type="primary" style="width:100%;" @click="handleSubmit('loginForm0')" :loading="loading">登录
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="手机快捷登录" name="1">
          <el-form
            label-position="left" :model="loginForm1"
            :rules="rules1" ref="loginForm1" label-width="0px">
            <el-form-item prop="mobile">
              <el-input type="text" v-model="loginForm1.mobile" auto-complete="off" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item prop="verCode">
              <el-input type="text" v-model="loginForm1.verCode" auto-complete="off" placeholder="请输入短信验证码" @keyup.enter.native="handleSubmit('loginForm1')">
                <el-button slot="append" @click="countDown">{{content}}</el-button>
              </el-input>
            </el-form-item>
          </el-form>
          <div>
            <el-button type="primary" style="width:100%;" @click="handleSubmit('loginForm1')" :loading="loading">登录</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div style="justify-content: space-between;display: flex;margin: 10px 0;">
        <a class="my-link" style="text-decoration: none;" href="/forgetPassword" target="_blank">忘记密码？</a>
        <a class="my-link" style="text-decoration: none;" href="/register">新用户注册</a>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { sendLoginVerifiCode } from '@/api/user/login'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      url: window.location.href,
      loading: false,
      sendSampleDialogVisible: false,
      content: '发送验证码',
      canClick: true, // 添加canClick
      // 记住密码
      loginType: '0',
      totalTime: 300,
      loginForm0: {
        userName: '',
        password: ''
      },
      loginForm1: {
        mobile: '',
        verCode: ''
      },
      rules0: {
        userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
        ]
      },
      rules1: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: '请输入正确的电话号码'
          }
        ],
        verCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      visited: false,
      next: '',
      to: '', // 可以接受参数
      router: null
    }
  },
  methods: {
    ...mapActions(['handleLogin']),
    show () {
      this.visited = true
    },
    handleSubmit (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          let param = {}
          if (this.loginType === '0') {
            param = this.loginForm0
          }
          if (this.loginType === '1') {
            param = this.loginForm1
            param.userName = this.loginForm1.mobile
          }
          param.loginType = this.loginType
          that.$store.dispatch('handleLogin', param).then((res) => {
            this.loading = false
            if (res.rtnCode === '0') {
              this.visited = false
              let paramx = null
              if (that.$router.history.pending) {
                paramx = that.$router.history.pending
                that.$router.push({ path: paramx.path, query: paramx.query })
              } else {
                paramx = that.$router.history.current
                that.$router.go(0)
              }
            } else {
              this.$message.error(res.msg)
            }
          })
          // })
        } else {
          this.loading = false
          return false
        }
      })
    },
    countDown () {
      this.$refs['loginForm1'].validateField('mobile', valid => {
        if (!valid) {
          let param = {}
          param.mobile = this.loginForm1.mobile
          sendLoginVerifiCode(param).then(res => {
            if (res.data.rtnCode !== '0') {
              this.$message.error(res.data.msg)
            } else {
              this.$message.success('验证码发送成功，请注意查收')
              if (!this.canClick) return // 改动的是这两行代码
              this.canClick = false
              this.content = this.totalTime + 's秒后重试'
              let clock = window.setInterval(() => {
                this.totalTime--
                this.content = this.totalTime + 's秒后重试'
                if (this.totalTime < 0) {
                  window.clearInterval(clock)
                  this.content = '重新发送验证码'
                  this.totalTime = 60
                  this.canClick = true // 这里重新开启
                }
              }, 1000)
            }
            this.loading = false
          }).catch(ex => {
            this.loading = false
            this.$message.error('注册异常')
          })
          // 表单验证通过
        }
      })
    }
  }
}
</script>

<style scoped>
  .login-container {
    margin: 0px auto;
    padding: 0 15px 15px 15px;
    background: #fff;
    text-align: left;
  }

</style>
